<template>
  <div class="col-md-11 visits__items">
    <div v-if="!consultationsVisitCurrent || consultationsVisitCurrent.length === 0">
      <div class="not-found row mt-5">
        <div class="col-3 d-flex justify-content-end">
          <img src="~@/assets/images/zero-illu-01.svg" alt="">
        </div>
        <div class="col-7">
          <div class="mb-3" v-html="$t('consultations.empty.text')">
          </div>
          <router-link :to="{name:'profile.order.find-doctor'}" class="btn w-auto">
            {{
              $t('consultations.empty.button')
            }}
          </router-link>
        </div>
      </div>
    </div>

    <div class="visits__item row"
         v-for="consultationVisitCurrent in consultationsVisitCurrent">
      <div class="date col-3">
        {{ formatDate(consultationVisitCurrent.date_time) }}
        <span>{{ formatTime(consultationVisitCurrent.date_time) }}</span>
      </div>

      <div class="col-1">
        <div class="avatar"
             :style="getDoctorAvatarUrl(consultationVisitCurrent.doctor_id) ? `background-image:url(${getDoctorAvatarUrl(consultationVisitCurrent.doctor_id)})`:''"
             :class="!getDoctorAvatarUrl(consultationVisitCurrent.doctor_id) ? 'avatar-placeholder':''"></div>
      </div>

      <div class="name col-4">
                <span v-if="consultationVisitCurrent.doctor_name">
                      {{ getFirstName(consultationVisitCurrent.doctor_name) }}<br>
                    {{ getOtherName(consultationVisitCurrent.doctor_name) }}
                </span>
        <span v-else>
                   {{ consultationVisitCurrent.name }}
                </span>
      </div>

      <div class="text col-4">
        {{ getClinicName(consultationVisitCurrent) }}
      </div>
      <div class="delimiter w-100"></div>
    </div>

    <b-modal ref="confirmationModal" centered hide-footer title="Підтвердження">
      Ви хочете видалити запис?

      <div class="mt-3">
        <button class="btn-blue" @click="cancelVisitCurrent()">
          Да
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import config from '@/helpers/configDateFormats';

export default {
  name: 'consultations-current',
  data() {
    return {
      selectedVisitCurrentCancel: null,
    };
  },
  computed: {
    ...mapGetters({
      consultationsVisitCurrent: 'consultationsCurrent',
      clinics: 'clinics',
      doctors: 'doctors'
    }),
  },
  methods: {
    getFirstName(name) {
      const [last_name = '', first_name = '', second_name = ''] = name.split(' ');
      return first_name;
    },
    getOtherName(name) {
      const [last_name = '', first_name = '', second_name = ''] = name.split(' ');
      return [last_name, second_name].join(' ');
    },
    getDoctorAvatarUrl(doctor_id) {
      let doctor = this.doctors.filter((doctor) => doctor.odrex_id === doctor_id)
      if (doctor.length > 0) {
        return doctor[0].image
      }
      return null
    },
    formatDate(date) {
      return moment(date).format(config.DATE_FORMAT_OUTPUT);
    },
    formatTime(date) {
      return moment(date).format(config.TIME_FORMAT);
    },
    getClinicName(visit) {
      let visitClinic = this.clinics.filter((item) => item.id === visit.clinic)
      if (visitClinic.length > 0) {
        return visitClinic[0].address
      }
      return ''
    },
    selectVisitCurrent(visit) {
      this.selectedVisitCurrentCancel = visit;
      this.$refs.confirmationModal.show();
    },
    cancelVisitCurrent() {
      this.$store
          .dispatch('setVisitCurrentCancel', this.selectedVisitCurrentCancel)
          .then(() => {
            this.$refs.confirmationModal.hide();

            this.$store.dispatch('getVisits', {serviceTypes: ['diagnostic', 'specialization', 'otherService']});
          });
    },
  },
}
</script>
